import { useState, useEffect } from "react";
import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import { showTickOnDoc } from "../../helper/common";
import FilePreviewModal from "../FilePreviewmodal";
import { RowButton, Button, Drawer, Icon } from "../design";
import "./docHistoryPopup.css";

const DocHistoryPopup = ({
  isOpen,
  onClose,
  docName,
  previousUploads = [],
  allData,
  handlePreviewDocument,
  user,
  selectedIndex,
  allForensicDocuments = {},
  currentLang,
  hideDownload = false,
}) => {
  const { _t } = useTranslator();
  const [filePreview, showFilePreview] = useState(false);
  const [showIndex, setShowIndex] = useState(null);
  const [innerIndex, setInnerIndex] = useState(null);

  useEffect(() => {
    setShowIndex(selectedIndex);
  }, [selectedIndex]);

  const getCleanFileName = (fileUrl) => {
    if (!fileUrl) return "";

    try {
      // Extract filename from URL
      const pathname = new URL(fileUrl).pathname;
      const fileName = pathname.split("/").pop();

      const parts = fileName.split(".");
      if (parts.length < 2) return fileName;

      const ext = parts.pop();
      const nameWithoutExt = parts.join(".");

      const segments = nameWithoutExt.split("_");

      if (segments.length > 1) {
        segments.pop(); // Remove last part after underscore
      }

      const cleanName = segments.join("");

      return `${cleanName}.${ext}`;
    } catch {
      // Fallback for plain filenames (not URLs)
      const parts = fileUrl.split(".");
      if (parts.length < 2) return fileUrl;

      const ext = parts.pop();
      const nameWithoutExt = parts.join(".");

      const segments = nameWithoutExt.split("_");
      if (segments.length > 1) {
        segments.pop();
      }

      return `${segments.join("")}.${ext}`;
    }
  };

  if (!isOpen) return null;

  const current = allData?.[selectedIndex];

  return (
    <>
      <Drawer
        open
        onClose={onClose}
        closeLabel={_t("close")}
        title={_t("documentHistory", "Text used in documeent history popup")}
      >
        <div className="doc-history">
          {allData?.length > 0 && (
            <>
              <div>
                <p className="doc-history__name">
                  {allForensicDocuments?.[allData?.[selectedIndex]?.file_name]
                    ?.localDocumentName?.[
                    currentLang === "en-us" ? "en" : "es"
                  ] ||
                    allForensicDocuments?.[allData?.[selectedIndex]?.file_name]
                      ?.documentNameTranslated?.[
                      currentLang === "en-us" ? "en" : "es"
                    ] ||
                    allForensicDocuments?.[allData?.[selectedIndex]?.file_name]
                      ?.documentName ||
                    _t(docName, "", "fixed")}
                  {showTickOnDoc(current, user) && (
                    <Icon
                      name="checkCircle"
                      size={16}
                      className="doc-history__tick"
                    />
                  )}
                </p>
                <p className="doc-history__meta">
                  {_t("uploadedOn")}{" "}
                  {moment(current?.created_at).format("DD/MM/YYYY")}
                </p>
              </div>
              <RowButton
                type="button"
                className="doc-history__preview"
                onClick={() => showFilePreview(true)}
              >
                {current?.file_name?.endsWith(".csv") ? (
                  <img src="/images/csv-dummy.svg" alt="" />
                ) : (
                  <iframe
                    title={getCleanFileName(current?.file_name)}
                    src={`${current?.url}`}
                    scrolling="no"
                  />
                )}
              </RowButton>
              <p className="doc-history__file">
                {getCleanFileName(current?.file_name)}
              </p>
            </>
          )}

          <div>
            <h3 className="doc-history__heading">
              {_t("previousUploads", "Text used in documeent history popup")}
            </h3>
            {previousUploads?.length > 1 ? (
              <ul className="doc-history__list">
                {previousUploads.slice(1).map((upload, index) => (
                  <li className="doc-history__item" key={index}>
                    <div className="doc-history__item-text">
                      <p className="doc-history__item-name">
                        {getCleanFileName(upload?.file_name ?? "N/A")}
                      </p>
                      <p className="doc-history__meta">
                        {_t("uploadedOn")}{" "}
                        {moment(upload?.created_at).format("DD/MM/YYYY")}
                      </p>
                    </div>
                    <Button
                      variant="ghost"
                      size="sm"
                      iconOnly
                      iconStart={<Icon name="eye" size={18} />}
                      aria-label={_t("view", "View")}
                      onClick={() => {
                        setInnerIndex(index + 1);
                        showFilePreview(true);
                      }}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              <p className="doc-history__meta">
                {_t(
                  "noDocHistoryAvailable",
                  "Text used in documeent history popup"
                )}
              </p>
            )}
          </div>
        </div>
      </Drawer>
      <FilePreviewModal
        show={filePreview}
        onClose={() => {
          setInnerIndex(null);
          setShowIndex(selectedIndex);
          showFilePreview(false);
        }}
        files={innerIndex ? previousUploads : allData}
        showIndex={innerIndex ? innerIndex : showIndex}
        hideDownload={hideDownload}
      />
    </>
  );
};

export default DocHistoryPopup;
